export default "__VITE_ASSET__1c2365f2__"